import styled from "styled-components";
import FONTS from "../../constants/fonts";

export const WholeWrapper = styled.div`
  width: 15.4rem;
  height: 9rem;
  padding: 1.4rem 2.4rem;
  background: linear-gradient(247.86deg, rgba(0, 221, 221, 0.15) 0%, rgba(0, 22, 116, 0.15) 94.22%);
  border-radius: 8px;
  border: 1px solid #ffffff1a;
  margin-right: 1rem;
`;

export const FlexWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  min-width: 4rem;
  min-height: 4rem;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4px;
  background: ${({ color }) => color || "#0686D833"};
`;

export const ValueContainer = styled.div`
  color: white;
  font-family: ${FONTS.UbuntuLight};
  font-size: 3.2rem;
  padding: 0 1rem;
  text-shadow: 0px 4px 4px #00000040, 0px 0px 18px #0096c6f2;
  opacity: 0.86;
`;

export const LabelContainer = styled.div`
  color: white;
  font-family: ${FONTS.UbuntuRegular};
  font-size: 1.6rem;
  padding: 0.6rem 0.3rem;
  text-shadow: 0px 4px 4px #00000040, 0px 0px 18px #0096c6f2;
  opacity: 0.86;
`;
